import React from 'react';

const StarFilled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M18.1991 4.06355L20.3811 10.0999H26.4886C28.2971 10.0999 29.1769 12.3094 27.8634 13.5525L23.2418 17.9265L24.9101 24.7281C25.3529 26.5334 23.3086 27.9136 21.7997 26.828L16.2453 22.8319L10.6909 26.828C9.182 27.9136 7.13762 26.5334 7.58043 24.7281L9.24321 17.9491L4.3185 13.5989C2.9379 12.3794 3.80047 10.0999 5.64257 10.0999H12.5648L14.4078 4.15153C14.9755 2.31929 17.5471 2.25961 18.1991 4.06355Z" />
  </svg>
);

export default StarFilled;
